var _path, _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCustomPin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 4C0 1.79086 1.79086 0 4 0H36C38.2091 0 40 1.79086 40 4V36C40 38.2091 38.2091 40 36 40H4C1.79086 40 0 38.2091 0 36V4Z",
    fill: "#E1E9F1"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_684_5733",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 7,
    y: 7,
    width: 26,
    height: 26
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 8.5,
    y: 8.5,
    width: 23,
    height: 23,
    fill: "#D9D9D9",
    stroke: "white",
    strokeWidth: 3
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_684_5733)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 18,
    r: 2,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.783 29.8931L17.783 29.8931L17.7903 29.8998C18.1021 30.1832 18.4606 30.3984 18.8574 30.5401C19.2241 30.671 19.6068 30.7417 20 30.7417C20.3931 30.7417 20.7759 30.671 21.1425 30.5401C21.5393 30.3984 21.8979 30.1832 22.2096 29.8998L22.2096 29.8998L22.2169 29.8931C23.3348 28.8612 24.3317 27.8478 25.2045 26.8527C26.08 25.8548 26.824 24.8727 27.4291 23.9063C28.0316 22.9441 28.5049 21.9947 28.8358 21.0589C29.1704 20.1123 29.3504 19.1728 29.3504 18.248C29.3504 15.4265 28.4286 13.0548 26.504 11.2798C24.6544 9.57395 22.4685 8.69641 20 8.69641C17.5314 8.69641 15.3455 9.57395 13.496 11.2798C11.5713 13.0548 10.6495 15.4265 10.6495 18.248C10.6495 19.1728 10.8295 20.1123 11.1641 21.0589L12.3806 20.6288L11.1641 21.0589C11.495 21.9947 11.9683 22.9441 12.5708 23.9062C13.176 24.8727 13.92 25.8548 14.7954 26.8527C15.6683 27.8478 16.6651 28.8612 17.783 29.8931ZM20.499 18.5458C20.3475 18.6973 20.2047 18.755 20 18.755C19.7952 18.755 19.6524 18.6973 19.501 18.5458C19.3495 18.3944 19.2918 18.2516 19.2918 18.0468C19.2918 17.8421 19.3495 17.6993 19.501 17.5478C19.6524 17.3964 19.7952 17.3387 20 17.3387C20.2047 17.3387 20.3475 17.3964 20.499 17.5478C20.6504 17.6993 20.7081 17.8421 20.7081 18.0468C20.7081 18.2516 20.6504 18.3944 20.499 18.5458Z",
    fill: "#2A52BE",
    stroke: "white",
    strokeWidth: 2.60718
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomPin);
export default __webpack_public_path__ + "static/media/custom-pin.ede679e7df64b363903b0d2a5f6da023.svg";
export { ForwardRef as ReactComponent };